export const FolderListModel = Symbol.for('FolderListModel');
